import {createAction} from "redux-actions";
import {handleActions} from '../../Utility/HandleActions';

//action types
const SAGA_LOAD_DATA_START = "DBM/DATA/DOWNLOAD/SAGA_LOAD_DATA_START";
const SAGA_LOAD_DATA_SUCCESS = "DBM/DATA/DOWNLOAD/SAGA_LOAD_DATA_SUCCESS";
const REQUEST_DOWNLOAD_FILE = "DBM/DATA/IMPORTER/REQUEST_DOWNLOAD_FILE";
const SAGA_DOWNLOAD_FILE_START = "DBM/DATA/IMPORTER/SAGA_DOWNLOAD_FILE_START";
const SAGA_DOWNLOAD_FILE_SUCCESS = "DBM/DATA/IMPORTER/SAGA_DOWNLOAD_FILE_SUCCESS";

//actions
const sagaLoadDataStart = createAction(SAGA_LOAD_DATA_START);
const sagaLoadDataSuccess = createAction(SAGA_LOAD_DATA_SUCCESS);
const requestDownloadFile = createAction(REQUEST_DOWNLOAD_FILE, args => ({type: args.type, data: args.data, options: args.options}));
const sagaDownloadFileStart = createAction(SAGA_DOWNLOAD_FILE_START);
const sagaDownloadFileSuccess = createAction(SAGA_DOWNLOAD_FILE_SUCCESS);

export const actionTypes = {
    SAGA_LOAD_DATA_START,
    SAGA_LOAD_DATA_SUCCESS,
    REQUEST_DOWNLOAD_FILE,
    SAGA_DOWNLOAD_FILE_START,
    SAGA_DOWNLOAD_FILE_SUCCESS
};

export const actions = {
    sagaLoadDataStart,
    sagaLoadDataSuccess,
    requestDownloadFile,
    sagaDownloadFileStart,
    sagaDownloadFileSuccess,
};

export const reducer = handleActions({
    [SAGA_LOAD_DATA_START]: () => (state) => state,
    [SAGA_LOAD_DATA_SUCCESS]: () => (state) => state,
});


export const selectors = {
};
